<template>
  <div>
    <!-- Image Column -->
    <div v-if="column.field === 'image'" class="image-holder">
      <img :src="row.image" class="product-icon" />
    </div>

    <!-- Title Column -->
    <div
      v-else-if="column.field === 'title'"
      @click="
        {
          row.size === 'Multiple' ? $emit('toggle-variants') : ''
        }
      "
      class="variant-name dropdown-container"
    >
      <div>
        <p :class="{ 'w-full': showVariants }">{{ row.title }}</p>
      </div>
      <div class="dropdown-container">
        <span
          v-if="row.size === 'Multiple'"
          :class="{ 'rotate-180': showVariants }"
        >
          <svg
            width="9"
            height="5"
            viewBox="0 0 9 5"
            fill="none"
            style="margin-top:10px;"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M4.5 5C4.38766 5 4.27531 4.95646 4.18974 4.86983L0.128691 0.758491C-0.0428969 0.584779 -0.0428969 0.303996 0.128691 0.130284C0.300278 -0.043428 0.577626 -0.043428 0.749214 0.130284L4.5 3.92752L8.25079 0.130284C8.42237 -0.043428 8.69972 -0.043428 8.87131 0.130284C9.0429 0.303996 9.0429 0.584779 8.87131 0.758491L4.81026 4.86983C4.72469 4.95646 4.61234 5 4.5 5Z"
              fill="#232220"
            />
          </svg>
        </span>
        <span
          class="pt-1"
          v-if="
            row.sortedProductVaraints.some(
              varient =>
                varient.needsReplenish === true ||
                varient.belowThreshold === true
            ) || row.belowThreshold
          "
        >
          <!-- Replenish Icon -->
          <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <rect
              width="16"
              height="16"
              fill="white"
              fill-opacity="0.01"
              style="mix-blend-mode:multiply"
            />
            <path
              d="M10.5088 13.3609L11.008 14.227L12.4969 13.3661V15H13.4953V13.3658L15.0008 14.2364L15.5 13.3701L13.9949 12.4998L15.4951 11.6323L14.9959 10.7661L13.4953 11.6339V10H12.4969V11.6336L10.9992 10.7676L10.5 11.6338L11.9977 12.4998L10.5088 13.3609Z"
              fill="#CE3C3C"
            />
            <path
              d="M7.99997 11.5C7.58577 11.5 7.24997 11.8358 7.24997 12.25C7.24997 12.6642 7.58577 13 7.99997 13C8.41417 13 8.74997 12.6642 8.74997 12.25C8.74997 11.8358 8.41417 11.5 7.99997 11.5Z"
              fill="#CE3C3C"
            />
            <path d="M8.49997 6H7.49997V10.5H8.49997V6Z" fill="#CE3C3C" />
            <path
              d="M8.99997 15H1.49997C1.32527 15 1.16317 14.9088 1.07262 14.7594C0.981917 14.6102 0.975817 14.4243 1.05637 14.2694L7.55637 1.76935C7.64242 1.6038 7.82122 1.5 7.99997 1.5C8.17872 1.5 8.35752 1.6038 8.44357 1.76935L11.8236 8.26935L10.9364 8.73065L7.99997 3.08375L2.32357 14H8.99997V15Z"
              fill="#CE3C3C"
            />
          </svg>
        </span>
      </div>
    </div>

    <!-- Size Column -->
    <div v-else-if="column.field === 'size'" class="size-column">
      <span
        v-if="row.size === 'Multiple'"
        @click="$emit('toggle-variants')"
        :class="{
          danger:
            row.sortedProductVaraints.some(
              varient =>
                varient.needsReplenish === true ||
                varient.belowThreshold === true
            ) || row.belowThreshold
        }"
      >
        Multiple
      </span>
      <span
        v-else
        :class="{
          danger:
            row.sortedProductVaraints.some(
              varient =>
                varient.needsReplenish === true ||
                varient.belowThreshold === true
            ) || row.belowThreshold
        }"
        >{{ row.size }}</span
      >
      <div v-if="showVariants" class="pt-5">
        <p
          class="w-max pb-2"
          v-for="variant in row.sortedProductVaraints"
          :key="variant.variantId"
          :class="{
            danger: variant.needsReplenish || variant.belowThreshold,
            'pb-5':
              variant.replenishQuantityError &&
              !variant.replenishQuantity &&
              variant.replenish
          }"
        >
          {{ variant.name }}
        </p>
      </div>
    </div>

    <!-- Quantity Column -->
    <div v-else-if="column.field === 'quantity'" class="quantity-column">
      <span
        v-if="row.size === 'Multiple'"
        @click="$emit('toggle-variants')"
        :class="{
          danger:
            row.sortedProductVaraints.some(
              varient =>
                varient.needsReplenish === true ||
                varient.belowThreshold === true
            ) || row.belowThreshold
        }"
      >
        {{ row.totalQuantity }}
      </span>
      <span
        v-else
        :class="{
          danger:
            row.sortedProductVaraints.some(
              varient =>
                varient.needsReplenish === true ||
                varient.belowThreshold === true
            ) || row.belowThreshold
        }"
      >
        {{ row.totalQuantity }}
      </span>
      <div v-if="showVariants" class="pt-5">
        <p
          class="pb-2"
          v-for="variant in row.sortedProductVaraints"
          :key="variant.variantId"
          :class="{
            danger: variant.needsReplenish || variant.belowThreshold,
            'pb-5':
              variant.replenishQuantityError &&
              !variant.replenishQuantity &&
              variant.replenish
          }"
        >
          {{ variant.inventoriesCount || 0 }}
        </p>
      </div>
    </div>

    <!-- Cost Column -->
    <div v-else-if="column.field === 'cost'" class="cost-column">
      <span class="w-max block" v-if="row.size === 'Multiple'">
        {{ getPriceRange(row.sortedProductVaraints) }}
      </span>
      <span v-else-if="row.size !== 'Multiple'">
        {{ formatCurrency(row.totalCost) }}
      </span>
      <div v-if="showVariants" class="pt-5">
        <p
          class="pb-2"
          v-for="variant in row.sortedProductVaraints"
          :key="variant.variantId"
          :class="{
            'pb-5':
              variant.replenishQuantityError &&
              !variant.replenishQuantity &&
              variant.replenish
          }"
        >
          {{ formatCurrency(parseInt(variant.price) || 0) }}
        </p>
      </div>
    </div>

    <!-- Replenish Column -->
    <div v-else-if="column.field === 'replenish'" class="replenish-column">
      <label v-if="!showVariants" class="checkbox-container">
        <div class="variant-item">
          <input
            type="checkbox"
            :checked="row.replenish || false"
            @click.stop="
              $event =>
                row.size === 'Multiple'
                  ? $emit('toggle-variants')
                  : $emit('toggle-single-replenish', $event, row)
            "
          />
          <span class="checkmark"></span> &nbsp;
          <div class="flex flex-col quantity-input-container">
            <input
              v-if="row.replenish && row.size !== 'Multiple'"
              type="text"
              min="1"
              placeholder="Qty"
              v-model="row.replenishQuantity"
              class="quantity-input"
              @change="
                () =>
                  row.size === 'Multiple'
                    ? $emit('toggle-variants')
                    : $emit('update-quantity', row)
              "
              :class="{
                'error-input':
                  row.replenishQuantityError && !row.replenishQuantity
              }"
            />

            <span
              v-if="
                row.replenishQuantityError &&
                  !row.replenishQuantity &&
                  row.replenish
              "
              class="quantity-error"
              >Enter quantity</span
            >
          </div>
          &nbsp;
        </div>
      </label>
      <div v-if="showVariants" class="checkbox-container-multiple">
        <label class="checkbox-container check-all">
          <input
            type="checkbox"
            :checked="areAllVariantsChecked(row.sortedProductVaraints)"
            @click.stop="$emit('toggle-check-all', $event, row)"
          />
          &nbsp;
          <span class="checkmark"></span>
        </label>

        <div class="pt-5">
          <label
            v-for="(variant, index) in row.sortedProductVaraints"
            :key="variant.variantId"
            class="checkbox-container mb-2"
            :class="{
              'mb-2': !variant.replenishQuantityError,
              'mb-1': !variant.replenishQuantityError && variant.replenish,
              'mb-0':
                variant.replenishQuantityError &&
                !variant.replenishQuantity &&
                variant.replenish
            }"
          >
            <div class="variant-item">
              <input
                type="checkbox"
                :checked="variant.replenish || false"
                @click.stop="
                  $emit('toggle-variant-replenish', $event, variant, index, row)
                "
              />
              <span class="checkmark"></span> &nbsp;
              <div class="flex flex-col quantity-input-container">
                <input
                  v-if="variant.replenish"
                  type="text"
                  placeholder="Qty"
                  v-model="variant.replenishQuantity"
                  @input="
                    $emit(
                      'set-variant-replenish-quantity',
                      $event,
                      variant.id,
                      index,
                      row
                    )
                  "
                  class="quantity-input"
                  :class="{
                    'error-input':
                      variant.replenishQuantityError &&
                      !variant.replenishQuantity
                  }"
                />
                <span
                  v-if="
                    variant.replenishQuantityError &&
                      !variant.replenishQuantity &&
                      variant.replenish
                  "
                  class="quantity-error"
                  >Enter quantity</span
                >
              </div>
            </div>
          </label>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TableCell',
  props: {
    column: Object,
    row: Object,
    showVariants: Boolean
  },
  methods: {
    formatCurrency(value) {
      return `$${value.toFixed(2)}`
    },
    areAllVariantsChecked(variants) {
      return variants.every(variant => variant.replenish)
    },
    handleChange(event) {
      console.log(event, 'event')
    },
    getPriceRange(variants) {
      if (!Array.isArray(variants) || variants.length === 0) return '$0.00'

      const prices = variants
        .map(variant => Number(variant.price))
        .filter(price => !isNaN(price))

      if (prices.length === 0) return '$0.00'

      const minPrice = Math.min(...prices)
      const maxPrice = Math.max(...prices)

      if (minPrice === maxPrice) {
        return this.formatCurrency(minPrice)
      }

      return `${this.formatCurrency(minPrice)} - ${this.formatCurrency(
        maxPrice
      )}`
    }
  }
}
</script>

<style scoped>
.dropdown-container {
  display: flex;
  gap: 6px;
  cursor: pointer;
}
.rotate-180 {
  transform: rotate(180deg);
}
.image-holder {
  display: flex;
  width: 50%;
  justify-content: center;
}
.danger {
  color: #ce3c3c;
}
.product-icon {
  height: 45px;
  object-fit: contain;
  padding: 0px 15px;
}
.size-column,
.quantity-column,
.cost-column,
.replenish-column {
  position: relative;

  p {
    font-size: 12px;
    padding-top: 5px;
  }
}
.checkbox-container,
.variant-item {
  display: flex;
  align-items: center;
  gap: 8px;

  &.mb-2 {
    margin-bottom: 0.44rem;
  }
  &.mb-0 {
    margin-bottom: 0.185rem;
  }
  &.mb-1 {
    margin-bottom: 0.37rem;
  }
}

.quantity-input {
  width: 50px;
  padding: 4px;
  font-size: 0.9rem;

  &.error-input {
    border-bottom: 1px solid #ce3c3c !important;
  }
}
.checkbox-container {
  display: flex;
  align-items: center;
  gap: 8px;
}

.variant-item {
  display: flex;
  align-items: center;
  gap: 8px;
}

.quantity-input-container {
  margin-bottom: 6px;
  margin-left: 11px;
}

.quantity-input {
  display: flex;
  width: 50px;
  position: relative;
  padding: 4px;
  font-size: 0.9rem;
  height: 19px;
  vertical-align: middle;
}

.quantity-error {
  color: #ce3c3c;
  font-size: 10px;
  font-weight: 800;
}
</style>
